import * as React from 'react';

export default function useOpenUrlOnCtrlClick(url: string) {
    return React.useCallback(
        (e: React.MouseEvent) => {
            if (e.button == 0 && (e.ctrlKey || e.metaKey)) {
                window.open(url);
            }
        },
        [url]
    );
}
